import React, { Fragment } from 'react';
import DailyComprehensiveRevenue from './DailyComprehensiveRevenue';

// Thin route entry — the V3 shell lives inside the view.
const DailyComprehensiveReport = () => (
    <Fragment>
        <DailyComprehensiveRevenue />
    </Fragment>
);

export default DailyComprehensiveReport;
